import React from "react";
import { Card, CardContent, makeStyles, Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { ApplicationRelativeRoutes } from "../..";
import { Pivot } from "../../dtos/pivot";

export const PivotCard = ({ pivot }: { pivot: Pivot }) => {
  const { pivotCard, statusMeta } = useStyles();
  const statusColor = !pivot.online ? "#888" : pivot.status === "Running" ? "#4caf50" : pivot.status === "Stopped" ? "#f44336" : "#888";
  const pivotTitle = `${pivot.name}: ${pivot.online ? pivot.status : "Offline"}`;
  const showFlow = pivot.online && pivot.status === "Running";

  return (
    <Link
      to={`${ApplicationRelativeRoutes.PIVOTS}/${pivot.id}`}
      style={{ textDecoration: "none" }}
    >
      <Card key={pivot.id} className={pivotCard}>
        <CardContent>
          <Grid container justify="space-between">
            <div style={{ color: statusColor }}>
              <header style={{ color: statusColor }}>{pivotTitle}</header>
              {pivot.serial}
            </div>
            {showFlow && (
              <div className={statusMeta}>
                Flow
                <div>
                  <b>{pivot.flow ?? 0} gpm</b>
                </div>
              </div>
            )}
          </Grid>
          <Grid container justify="space-between">
            <div>
              Angle: <b>{pivot.anglePercent}°</b>
            </div>
            <div>
              Session Status: <b>{pivot.online ? pivot.status : "Offline"}</b>
            </div>
          </Grid>
        </CardContent>
      </Card>
    </Link>
  );
};

const useStyles = makeStyles({
  pivotCard: {
    margin: "10px 0",
    cursor: "pointer",
    "& header": {
      fontWeight: "bold"
    }
  },
  statusMeta: {
    textAlign: "right"
  }
});
